import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" {...props}><path fillRule="nonzero" d="M1.125 3L0 4.006 8 13l8-8.994L14.875 3l-6.863 7.743z" /></svg>);